function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PropTypes from "prop-types";
import React from "react";
import { StyleSheet, Text, View, Image } from "react-native";
import { BlockComponent } from "../../framework/src/BlockComponent";
export default class CustomTextItem extends BlockComponent {
  render() {
    return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
      style: {
        flexDirection: "row",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement(Text, {
      onPress: this.props.onPress,
      style: styles.item
    }, this.props.content), /*#__PURE__*/React.createElement(Image, {
      style: {
        height: 20,
        width: 20,
        marginRight: 10
      },
      source: require("./arrow_right.png")
    })), /*#__PURE__*/React.createElement(View, {
      style: styles.seprator
    }));
  }
}
_defineProperty(CustomTextItem, "propTypes", {
  content: PropTypes.string.isRequired
});
const styles = StyleSheet.create({
  item: {
    backgroundColor: "#00000000",
    padding: 18,
    color: "black",
    fontSize: 18,
    fontWeight: "bold",
    flex: 1,
    flexDirection: "row"
  },
  seprator: {
    backgroundColor: "#6200EE",
    color: "#6200EE",
    height: 1
  }
});